import {Component, effect, input} from '@angular/core'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable
} from '@angular/material/table'
import {BaseTable, BindingPipe} from '@sparbanken-syd/sparbanken-syd-theme'
import {InterestInput} from '../interest-input/interest-input'
import {FormsModule} from '@angular/forms'
import {IInterestRow} from '../../../0-application/types'

@Component({
  selector: 'spb-interest-table',
  imports: [
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
    MatHeaderCellDef,
    BindingPipe,
    InterestInput,
    FormsModule
  ],
  templateUrl: './interest-table.html',
  styleUrls: ['../../tables.scss', './interest-table.scss']
})
export class InterestTable extends BaseTable<IInterestRow> {

  /* v8 ignore next */
  public interests =
    input.required<IInterestRow[]>()

  public bindings = ['3', '12', '24', '36', '48', '60', '84', '120']

  constructor() {
    super()
    this.columns.set(['name', ...this.bindings])

    effect(() => {
      this.items.data = this.interests()
    })
  }
}
